/**
 * @generated SignedSource<<794e29bbfc4f6fecbd8aac0800941a9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewTally_item$data = {
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPriceTable_item" | "ImageMultiSkuOverlay_item">;
  readonly " $fragmentType": "CheckoutReviewTally_item";
};
export type CheckoutReviewTally_item$key = {
  readonly " $data"?: CheckoutReviewTally_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewTally_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewTally_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ImageMultiSkuOverlay_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPriceTable_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "4b671dcf8d1be1440507ecc467852303";

export default node;
